import { FC, forwardRef, ReactNode } from 'react';
import { GridProps } from '@chakra-ui/react';
import ContentSection, { SectionHeading } from './ContentSection';
import { FieldsLayout } from './ArticleLayout';

/*
 * Helper component to deal with grid-column -chain being broken in Fields.
 * Used to create full bleed sections with background and still maintaining correct ContentSection -flow
 */

export const sectionPadding = [7, null, 14];

const Section = forwardRef<
  HTMLDivElement,
  Omit<GridProps, 'title'> & {
    title?: ReactNode;
    fullSection?: boolean;
    contentWidth?: string;
  }
>(({ children, title, fullSection = false, contentWidth, ...styles }, ref) => (
  <FieldsLayout
    ref={ref}
    as="section"
    layerStyle="fullWidth"
    py={fullSection ? sectionPadding : undefined}
    {...styles}
  >
    {fullSection ? (
      children
    ) : (
      <ContentSection contentWidth={contentWidth}>
        {title && <SectionHeading>{title}</SectionHeading>}
        {children}
      </ContentSection>
    )}
  </FieldsLayout>
));

export default Section;
